import { render, staticRenderFns } from "./Lhc.vue?vue&type=template&id=0672f655&scoped=true"
import script from "./Lhc.vue?vue&type=script&lang=js"
export * from "./Lhc.vue?vue&type=script&lang=js"
import style0 from "./Lhc.vue?vue&type=style&index=0&id=0672f655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672f655",
  null
  
)

export default component.exports